import { Routes, Route, Outlet, BrowserRouter } from "react-router-dom";
import { appRoutes } from "../commons/constants";
import { Main as MainLayout } from "../commons/components/layouts/Main";

import Home from "./Home";
import { Lores, Lore } from "./lores";
import Rarity from "./Rarity";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <MainLayout>
              <Outlet />
            </MainLayout>
          }
        >
          <Route path={appRoutes.HOME} element={<Home />} />
          <Route path={appRoutes.LORES} element={<Lores />}></Route>
          <Route path={appRoutes.LORE} element={<Lore />} />
          <Route path={appRoutes.RARITY} element={<Rarity />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
